const globals = {
  /* eslint-disable no-undef, object-shorthand */
  __DEV__: __DEV__,
  __ENV__: __ENV__,
  __SERVER__: __SERVER__,
  __CLIENT__: __CLIENT__,
  /* eslint-enable no-undef */
};

/* eslint-disable array-callback-return */
Object.keys(globals).map(key => {
  global[key] = globals[key];
});

export default globals;
